import React from 'react';
import AuditSessions from '../../gestion-audit/AuditSessions';

export default function AuditSessionsMobile() { return <AuditSessions mobile />; }
